<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        class="form-control select"
                        v-model="search.customer"
                        :options="optionCustomer"
                        :customLabel="customerLabel"
                        :show-labels="false"
                        placeholder="ค้นหาลูกค้า"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        class="form-control select"
                        v-model="search.sale"
                        :options="OptionSeller"
                        :customLabel="SaleLabel"
                        :show-labels="false"
                        placeholder="ค้นหาเซลล์"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        class="form-control select"
                        v-model="search.area"
                        @input="getProvince(search.area)"
                        :options="optionGeography"
                        label="name"
                        :show-labels="false"
                        placeholder="เลือกภาค"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        v-if="search.area"
                        class="form-control select"
                        v-model="search.province"
                        @input="getDistricts(search.province)"
                        :options="optionProvince"
                        label="name"
                        :show-labels="false"
                        placeholder="เลือกจังหวัด"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        v-if="search.province && search.area"
                        class="form-control select"
                        v-model="search.district"
                        @input="getSubDistricts(search.district)"
                        :options="optionDistricts"
                        label="name"
                        :show-labels="false"
                        placeholder="เลือกเขต / อำเภอ"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        v-if="search.province && search.area && search.district"
                        class="form-control select"
                        v-model="search.sub_districts"
                        :options="optionSubDistricts"
                        label="name"
                        :show-labels="false"
                        placeholder="เลือกตำบล"
                        track-by="id">
                    </multiselect>
                    <multiselect
                        class="form-control select"
                        v-model="search.distance_order"
                        :options="optionOrder"
                        label="name"
                        :show-labels="false"
                        placeholder="เลือกการเรียงข้อมูล"
                        track-by="value">
                    </multiselect>
                    <button @click="searchShipping"
                            class="btn btn-success my-2 my-sm-0"
                            type="button">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button @click="showIncrementShippingModal"
                            class="btn btn-warning my-2 my-sm-0"
                            type="button">
                        <icon name="pencil-alt"></icon>
                        แก้ไข
                    </button>
                    &nbsp
                    <button class="btn btn-primary my-2 my-sm-0"
                            @click="printCustomerSubTransport"
                            type="button">
                        <icon name="print"></icon>
                        พิมพ์ค่าเที่ยวของลูกค้าย่อย
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">
                        <input type="checkbox" v-model="selectAll">
                    </th>
                    <th>
                        ชื่อเซลล์
                    </th>
                    <th scope="col">ชื่อร้านลูกค้าหลัก</th>
                    <th scope="col">ชื่อร้านลูกค้ารายย่อย</th>
                    <th scope="col">ที่อยู่</th>
                    <template v-for="transport in transportType">
                        <th scope="col">{{ transport.name }}</th>
                    </template>
                    <th scope="col">ระยะทางไป-กลับ / กม.</th>
                    <th scope="col">แก้ไข / ลบ</th>

                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in shipping_customer">
                    <td>
                        <input type="checkbox"
                               v-model="checkbox_id"
                               :value="data.id"/>
                    </td>
                    <td>{{ data.customer.sale ? data.customer.sale_name : '-' }}</td>
                    <td>{{ data.customer.customer_id }} {{ data.customer.store_name }}</td>
                    <td class="text-left">
                        {{ data.store_name ? data.store_name : data.first_name }}
                    </td>
                    <td>
                        <template v-if="data.address">
                            {{ data.address }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <template v-if="data.transport_price.length > 0">
                        <td v-for="transport in data.transport_price">
                            <template v-if="transport.fee > 0">
                                {{ transport.fee }}
                            </template>
                            <template v-else>-</template>
                        </td>
                    </template>
                    <template v-else>
                        <td v-for="i in transportType">
                            -
                        </td>
                    </template>
                    <td>
                        <template v-if="data.distance">
                            {{ data.distance | amount }}
                        </template>
                        <template v-else>
                            -
                        </template>
                    </td>
                    <td>
                        <a @click="showEditShipping(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>&nbsp&nbsp
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div v-if="shipping_customer.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getShippingPage">
            </vue-pagination>
        </div>
        <b-modal hide-header hide-footer ref="edit_Sub">
            <div style="text-align: center;">
                <shipping-modal @submit="editTransportCustomer">
                </shipping-modal>
            </div>
        </b-modal>

        <!-------increment and reduce------>
        <b-modal hide-header hide-footer ref="increment_shipping">
            <div>
                <edit-shipping-sub-modal @submit="editShippingTransport">
                </edit-shipping-sub-modal>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="loading">
            <loading :status="status_loading" :msg="msg" @submit="hideLoadingModal">
            </loading>
        </b-modal>
        <!--        <pre class="alert alert-primary text-left">{{ checkbox_id }}</pre>-->
        <!--        <pre class="alert alert-success text-left">{{ shipping_customer }}</pre>-->
        <br/>
    </div>
</template>

<script>
import {mapState} from "vuex";
import ShippingModal from "./ShippingSubModal";
import Modal from "bootstrap-vue/es/components/modal/modal";
import EditShippingSubModal from "./EditShippingSubModal";
import moment from "moment";
import Multiselect from "vue-multiselect";
import VuePagination from "../../Pagination";
import Loading from "../../Utility/Loading";
import {domain} from "../../../util/Constants";

export default {
    components: {
        Loading,
        VuePagination,
        EditShippingSubModal,
        Modal,
        Multiselect,
        ShippingModal
    },
    name: "shipping-fee",
    data() {
        return {
            checkbox_id: [],
            select_all: false,
            event_submit: false,
            page: 1,
            test: "",
            status_loading: 1,
            msg: '',
            optionCustomer: [],
            optionOrder: [
                {value: '', name: 'เรียงตามจังหวัด(ปรกติ)'},
                {value: 'asc', name: 'เรียงตามระยะทางน้อย-มาก'},
                {value: 'desc', name: 'เรียงตามระยะทางมาก-น้อย'}
            ],
        }
    },
    created() {
        let data = {
            area_id: '',
            province_id: '',
            districts_id: '',
            sub_districts_id: '',
            customer_id: '',
            sale_id: '',
            order: '',
        };
        this.$store.dispatch("Shipping/getCustomerSubShipping", {
            page: 1,
            data,
        });
        this.$store.dispatch('TransportType/setTransportTypes');
        this.$store.dispatch('Common/setGeography');
        this.$store.dispatch("Shipping/clearSearch");
        this.$store.dispatch('Seller/get');
        this.getCustomerAll();
    },
    computed: {
        ...mapState({
            shipping_customer: (state) => {
                return state.Shipping.customer_shipping_sub
            },
            OptionSeller: state => {
                return state.Seller.data;
            },
            transportType: state => {
                return state.TransportType.transportTypeList.filter(data => data.id != 4);
            },
            user: state => {
                return state.Auth.user;
            },
            optionProvince: state => {
                return state.Common.province;
            },
            optionDistricts: state => {
                return state.Common.districts;
            },
            optionSubDistricts: state => {
                return state.Common.sub_districts;
            },
            optionGeography: state => {
                return state.Common.geography;
            },
            dataPaginate: state => {
                return state.Shipping.dataPaginate;
            },
            selected: state => {
                return state.Shipping.selected
            },
            search: state => {
                return state.Shipping.search;
            }

        }),
        selectAll: {
            get: function () {
                return this.shipping_customer ? this.checkbox_id.length >= this.shipping_customer.length : false;
            },
            set: function (value) {
                this.select_all = false;
                if (value) {
                    this.select_all = true;
                    this.getsearchShipping();
                } else {
                    this.select_all = false;
                    this.checkbox_id = [];
                }
            },
        }
    },
    methods: {
        editShippingTransport(submitValue) {
            const currentDate = moment().format("YYYY-MM-DD");
            if (submitValue) {
                submitValue.forEach(value => {
                    value.fee = parseFloat(value.fee);
                });
                let data = {
                    date: currentDate,
                    user_id: this.user.id,
                    select_all_status: this.select_all,
                    select_all_type: 0,
                    checkbox_id: this.checkbox_id,
                    sale_id: this.search.sale ? this.search.sale.id : null,
                    transport_customer: submitValue,
                    search: this.search,
                    sale : this.search.sale ? this.search.sale.id :'',
                    area : this.search.area ? this.search.area.id :'',
                    province : this.search.province ? this.search.province.id :'',
                    district : this.search.district ? this.search.district.id :'',
                    sub_districts: this.search.sub_districts ? this.search.sub_districts.id : '',
                };
                if (this.search.area && !this.search.province && !this.search.district) {
                    data.select_all_type = 1 //เปลี่ยนแปลงค่าขนส่งทั้งภาค
                } else if (this.search.province && !this.search.district) {
                    data.select_all_type = 2 //เปลี่ยนแปลงค่าขนส่งทั้งจังหวัด
                } else if (this.search.province && this.search.district) {
                    data.select_all_type = 3 //เปลี่ยนแปลงค่าขนส่งทั้งจังหวัดและอำเภอ
                } else if (this.search.sale && !this.search.area && !this.search.province && !this.search.district) {
                    data.select_all_type = 4 //เปลี่ยนแปลงค่าขนส่งทั้งเซล
                } else {
                    data.select_all_type = 0
                }
                this.$store.dispatch('Shipping/createSub', data).then(() => {
                    this.hideIncrementShippingModal();
                    this.$router.push({
                        name: "edit-shipping"
                    })
                });
            } else {
                this.hideIncrementShippingModal();
            }

        },
        SaleLabel(option) {
            return `${option.sale_id} - ${option.name}`
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        getCustomerAll() {
            this.$store.dispatch("Customer/setAllCustomer").then(res => {
                this.optionCustomer = res;
            });
        },
        customerLabel(option) {
            return `${option.customer_id} - ${option.store_name}`
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getProvince(area) {
            if (area) {
                this.$store.dispatch('Common/setProvinceFromGeography', area.id);
            } else {
                this.search.province = null;
                this.search.district = null;
            }
        },
        getDistricts(province) {
            if (province) {
                this.$store.dispatch('Common/setDistrict', province.code);
            } else {
                this.search.district = null;
            }
        },
        getSubDistricts(district) {
            if (district) {
                this.$store.dispatch('Common/setSubDistrict', district.district_id);
            } else {
                this.search.district = null;
            }
        },
        showEditShippingModal() {
            this.$refs.edit_Sub.show();
        },
        hideEditShippingModal() {
            this.$refs.edit_Sub.hide();
        },
        showIncrementShippingModal() {
            if (this.checkbox_id.length > 0 ||
                ((this.search.area || this.search.customer || this.search.province || this.search.district || this.search.sale) && this.select_all)) {
                this.$refs.increment_shipping.show();
            } else {
                alert('กรุณาเลือกรายการที่ต้องการแก้ไข')
            }
        },
        hideIncrementShippingModal() {
            this.$refs.increment_shipping.hide();
        },
        showEditShipping(id) {
            this.showEditShippingModal();
            this.$store.dispatch('Customer/showSub', id)
        },
        //พิมพ์ค่าเที่ยวของลูกค้าหลัก
        // printCustomerTransport(){
        //     let data = {
        //         sale_id : this.search.sale ? this.search.sale.id : '',
        //     }
        //     window.open(`${domain}/update/log_customer_transport?sale_id=${data.sale_id}`)
        // },
        editTransportCustomer(submitData) {
            if (submitData) {
                this.showLoadingModal();
                this.status_loading = 1;
                this.msg = "กำลังบันทึกข้อมูล กรุณารอสักครู่";
                this.$store.dispatch('Customer/uploadTransportOtherCustomer', submitData)
                    .then(() => {
                        this.status_loading = 2;
                        this.msg = "บันทึกสำเร็จ";
                        this.getShippingPage();
                    });
            } else {
                this.hideEditShippingModal();
            }
        },
        searchShipping() {
            let data = {
                area_id: this.search.area ? this.search.area.id : '',
                province_id: this.search.province ? this.search.province.id : '',
                districts_id: this.search.district ? this.search.district.id : '',
                sub_districts_id: this.search.sub_districts ? this.search.sub_districts.id : '',
                customer_id: this.search.customer ? this.search.customer.id : '',
                sale_id: this.search.sale ? this.search.sale.id : '',
                order: this.search.distance_order ? this.search.distance_order.value : '',
                select_all: '',
            };
            this.showLoadingModal();
            this.status_loading = 1;
            this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
            this.$store.dispatch("Shipping/getCustomerSubShipping", {
                page: 1,
                data: data
            }).then(() => {
                this.hideLoadingModal();
            })
        },
        getsearchShipping() {
            this.checkbox_id = [];
            let data = {
                area_id: this.search.area ? this.search.area.id : '',
                province_id: this.search.province ? this.search.province.id : '',
                districts_id: this.search.district ? this.search.district.id : '',
                sub_districts_id: this.search.sub_districts ? this.search.sub_districts.id : '',
                customer_id: this.search.customer ? this.search.customer.id : '',
                sale_id: this.search.sale ? this.search.sale.id : '',
                order: this.search.distance_order ? this.search.distance_order.value : '',
                select_all: 'all',
            };
            this.showLoadingModal();
            this.status_loading = 1;
            this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
            this.$store.dispatch("Shipping/getCustomerSubShipping", {
                page: 1,
                data: data
            }).then(res => {
                this.checkbox_id = res[1].map(a => a.id);
                this.hideLoadingModal();
            })
        },
        printCustomerSubTransport() {
            let data = {
                area_id: this.search.area ? this.search.area.id : '',
                province_id: this.search.province ? this.search.province.id : '',
                districts_id: this.search.district ? this.search.district.id : '',
                sub_districts_id: this.search.sub_districts ? this.search.sub_districts.id : '',
                customer_id: this.search.customer ? this.search.customer.id : '',
                sale_id: this.search.sale ? this.search.sale.id : '',
                order: this.search.distance_order ? this.search.distance_order.value : '',
            };
            window.open(`${domain}/export-sub-pdf?customer_id=${data.customer_id}&area_id=${data.area_id}&province_id=${data.province_id}&districts_id=${data.districts_id}&sub_districts_id=${data.sub_districts_id}&sale_id=${data.sale_id}&order=${data.order}`);
        },
        getShippingPage() {
            let data = {
                area_id: this.search.area ? this.search.area.id : '',
                province_id: this.search.province ? this.search.province.id : '',
                districts_id: this.search.district ? this.search.district.id : '',
                sub_districts_id: this.search.sub_districts ? this.search.sub_districts.id : '',
                customer_id: this.search.customer ? this.search.customer.id : '',
                sale_id: this.search.sale ? this.search.sale.id : '',
                order: this.search.distance_order ? this.search.distance_order.value : '',
                select_all: '',
            };
            this.page = this.dataPaginate.current_page;
            this.showLoadingModal();
            this.msg = "กำลังดาวโหลดข้อมูล กรุณารอสักครู่";
            this.status_loading = 1;
            this.$store.dispatch("Shipping/getCustomerSubShipping", {
                page: this.page,
                data: data
            }).then(() => {
                this.hideLoadingModal();
            })
        }
    }
}
</script>

<style scoped>
.select {
    border: 0;
}
</style>
